var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChatIcon = function SvgChatIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7778 11.7576C15.255 11.7576 10.7778 16.2347 10.7778 21.7576V62.3826C10.7778 67.9054 15.255 72.3826 20.7778 72.3826H41.7648L48.8874 89.0387C49.2377 89.8578 50.4035 89.8445 50.735 89.0176L57.4044 72.3826H77.5695C83.0924 72.3826 87.5695 67.9054 87.5695 62.3826V21.7576C87.5695 16.2347 83.0924 11.7576 77.5695 11.7576H20.7778Z",
    fill: "#646EC8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3125 48.5C26.9643 48.5 24.25 45.7857 24.25 42.4375C24.25 39.0893 26.9643 36.375 30.3125 36.375C33.6607 36.375 36.375 39.0893 36.375 42.4375C36.375 45.7857 33.6607 48.5 30.3125 48.5ZM50.5208 48.5C47.1726 48.5 44.4583 45.7857 44.4583 42.4375C44.4583 39.0893 47.1726 36.375 50.5208 36.375C53.8691 36.375 56.5833 39.0893 56.5833 42.4375C56.5833 45.7857 53.8691 48.5 50.5208 48.5ZM70.7292 48.5C67.381 48.5 64.6667 45.7857 64.6667 42.4375C64.6667 39.0893 67.381 36.375 70.7292 36.375C74.0774 36.375 76.7917 39.0893 76.7917 42.4375C76.7917 45.7857 74.0774 48.5 70.7292 48.5Z",
    fill: "white"
  })));
};
export default SvgChatIcon;